const LoadingIndicator = () => {
  return (
    <div className="loading-container">
      <div className="loading-animation">
        {/* Orbital orbs - rotating around center */}
        <div className="loading-orbit loading-orbit--1">
          <div className="loading-orb loading-orb--1"></div>
        </div>
        <div className="loading-orbit loading-orbit--2">
          <div className="loading-orb loading-orb--2"></div>
        </div>
        <div className="loading-orbit loading-orbit--3">
          <div className="loading-orb loading-orb--3"></div>
        </div>
        <div className="loading-orbit loading-orbit--4">
          <div className="loading-orb loading-orb--4"></div>
        </div>

        {/* Multiple expanding rings */}
        <div className="loading-center">
          <div className="loading-center__core"></div>
          <div className="loading-center__pulse loading-center__pulse--1"></div>
          <div className="loading-center__pulse loading-center__pulse--2"></div>
          <div className="loading-center__ring loading-center__ring--1"></div>
          <div className="loading-center__ring loading-center__ring--2"></div>
          <div className="loading-center__ring loading-center__ring--3"></div>
        </div>

        {/* Rotating gradient rings */}
        <svg className="loading-ring loading-ring--outer" viewBox="0 0 100 100">
          <defs>
            <linearGradient id="loadingGradientOuter" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#4ecdc4" stopOpacity="0.8" />
              <stop offset="50%" stopColor="#bb8fce" stopOpacity="0.8" />
              <stop offset="100%" stopColor="#fdb1ec" stopOpacity="0.8" />
            </linearGradient>
          </defs>
          <circle
            className="loading-ring__path"
            cx="50"
            cy="50"
            r="42"
            fill="none"
            stroke="url(#loadingGradientOuter)"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
        </svg>

        <svg className="loading-ring loading-ring--inner" viewBox="0 0 100 100">
          <defs>
            <linearGradient id="loadingGradientInner" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#fdb1ec" stopOpacity="0.9" />
              <stop offset="50%" stopColor="#bb8fce" stopOpacity="0.9" />
              <stop offset="100%" stopColor="#4ecdc4" stopOpacity="0.9" />
            </linearGradient>
          </defs>
          <circle
            className="loading-ring__path loading-ring__path--reverse"
            cx="50"
            cy="50"
            r="35"
            fill="none"
            stroke="url(#loadingGradientInner)"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>

        {/* Sparkle particles */}
        <div className="loading-sparkle loading-sparkle--1"></div>
        <div className="loading-sparkle loading-sparkle--2"></div>
        <div className="loading-sparkle loading-sparkle--3"></div>
        <div className="loading-sparkle loading-sparkle--4"></div>
      </div>
      <p className="loading-text">Loading...</p>
    </div>
  );
};

export default LoadingIndicator;
